import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Button,
  makeStyles,
  Grid,
} from "@material-ui/core";
import { TextField } from "@ofqual/portal-components/components/TextField";
import { FileInput } from "@ofqual/portal-components/components/FileInput";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { Error } from "../../../common/Error";
import { ActionDialogProps } from "./DialogProps";
import { Select } from "@ofqual/portal-components/components/Select";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import { documentTypeService } from "../../../../services";
import { sendDocuments } from "../../../../redux/actions";

const useStyles = makeStyles((theme) => ({
  dialogActions: {
    padding: 15,
  },
  body: {
    marginTop: 5,
    marginBottom: 5,
  },
}));

export const DocumentDialog: React.FC<ActionDialogProps> = ({
  onClose,
  application,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { handleSubmit, control, errors } = useForm({
    defaultValues: { note: "", files: [], documentType: "" },
  });

  const handleSendMessage = (data: {
    files: File[];
    documentType: string;
    note: string;
  }) => {
    dispatch(
      sendDocuments(
        application.organisationID.toString(),
        application.id,
        data.files,
        data.documentType,
        data.note
      )
    );
    onClose();
  };

  const [documentTypeLookups] = useLookup(documentTypeService);

  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      data-test="document-scope-activity-dialog"
    >
      <DialogTitle data-test="document-scope-activity-dialog-title">
        Add a Document
        <Divider />
      </DialogTitle>

      <DialogContent>
        <form>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Controller
                control={control}
                name="files"
                rules={{ required: true }}
                as={<FileInput multiple={true} />}
              />
              {errors.files && (
                <Error>
                  &nbsp;&nbsp;Please select one or more files to attach
                </Error>
              )}
            </Grid>

            <Grid item xs={6}>
              <Controller
                control={control}
                name="documentType"
                rules={{ required: true }}
                as={
                  <Select label="Document type" datatest="document-type">
                    {documentTypeLookups}
                  </Select>
                }
              />
              {errors.documentType && <Error>This field is required</Error>}
            </Grid>

            <Grid item xs={12}>
              <Controller
                control={control}
                name="note"
                as={
                  <TextField
                    data-test="note"
                    multiline
                    rows={5}
                    label="Note (Optional)"
                  />
                }
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button
          onClick={onClose}
          color="primary"
          data-test="close-attach-doc-button"
        >
          Close
        </Button>
        <Button
          onClick={handleSubmit(handleSendMessage)}
          color="primary"
          data-test="confirm-attach-doc-button"
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
